import pkg from '../package.json';
const {Voonto} = window;

Voonto.ready.then((app) => {
   Voonto.require('jquery').then(function ($) {
     window.paywall = {$};

     require('./paywall-autoload');
  });
});

export const VERSION = pkg.version;
export var initialized = false;



// WEBPACK FOOTER //
// ./src/paywall-index.js